import {useMutation, useQueryClient} from "@tanstack/react-query";
import {toast} from "react-toastify";
import {useDispatch} from "react-redux";
import {setSilent} from "../../../../redux/meta.js";
import {update} from "../../../app/setters/update.js";

export const useOdrzucAnulujProjekt = () => {
    const queryClient = useQueryClient();
    const dispatch = useDispatch()

    return useMutation({
        mutationFn: (data) => update(`/oper/rejestr/odrzuc-anuluj`, data),
        onSuccess: ({message, status}) => {
            dispatch(setSilent(true))
            status === 'success' ? toast.success(message) : toast.error(message)
        },
        onSettled: async () => {
            await queryClient.invalidateQueries({
                predicate: query =>
                    typeof query.queryKey[0] === 'string' &&
                    query.queryKey[0].includes('rejestr/lista'),
            });
        },
        onError: (error) => {
            toast.error(error?.message || 'Wystąpił błąd')
        }
    });
};
